import { AnimatePresence, motion } from "framer-motion";

interface AnnouncementBarItem {
  text: string;
  url: string;
}

interface AnnouncementBarProps {
  items: AnnouncementBarItem[];
}

export const AnnouncementBarConfig = {
  key: "announcement-bar",
  component: AnnouncementBar,
};

export default function AnnouncementBar({ items }: AnnouncementBarProps) {
  const repeat = 10;

  return (
    <div
      className="
        xrelative xflex xitems-center xjustify-stretch xw-full
      xbg-light-green
      xfont-grotesque  xtext-extra-dark-green xfont-semibold xuppercase
      xh-announcement-mobile  xtext-2xl
      sm:xh-announcement-desktop  sm:xtext-3xl

      xoverflow-hidden
      "
    >
      <motion.div
        initial={{ x: `50` }}
        animate={{ x: `-50%` }}
        transition={{ duration: 60, repeat: Infinity, ease: "linear" }}
        className="xflex xflex-shrink-0 xgap-64 "
      >
        {Array.from({ length: repeat }).map((_) =>
          items.map(({ url, text }) => {
            return (
              <span
                className="
                xflex xflex-nowrap xitems-center xjustify-center xfont-bold
                xw-full
              "
              >
                {url.length > 0 ? (
                  <a href={url} className="xunderline ">
                    {text}
                  </a>
                ) : (
                  text
                )}
              </span>
            );
          })
        )}
      </motion.div>
    </div>
  );
}
